import { defineComponent as O, computed as S, createBlock as p, openBlock as n, unref as s, withCtx as c, createElementVNode as i, createVNode as u, normalizeClass as T, toDisplayString as m, createCommentVNode as w, withModifiers as k, createTextVNode as x, createElementBlock as y, Fragment as $, renderList as j } from "vue";
import { Disclosure as z, DisclosureButton as N, DisclosurePanel as E } from "@headlessui/vue";
import { DataTableCell as b, DataTableRow as F, DataTableCheckbox as I } from "@scalar/api-client/components/DataTable";
import { ScalarButton as C, ScalarIcon as R } from "@scalar/components";
const L = { class: "flex h-fit w-full" }, M = { class: "flex-1" }, P = { class: "flex items-center gap-1.75" }, U = {
  class: "grid auto-rows-auto",
  style: { gridTemplateColumns: "1fr auto" }
}, q = { key: 0 }, G = { class: "font-code text-xs" }, W = /* @__PURE__ */ O({
  __name: "OAuthScopesInput",
  props: {
    flow: {},
    updateScheme: { type: Function }
  },
  setup(l) {
    const D = S(
      () => {
        var e;
        return Object.entries(((e = l.flow) == null ? void 0 : e.scopes) ?? {}).map(([t, o]) => ({
          id: t,
          label: t,
          description: o
        }));
      }
    ), d = S(() => {
      var e;
      return ((e = l.flow) == null ? void 0 : e.selectedScopes) || [];
    });
    function V(e, t) {
      t ? l.updateScheme(`flows.${l.flow.type}.selectedScopes`, [
        ...d.value,
        e
      ]) : l.updateScheme(
        `flows.${l.flow.type}.selectedScopes`,
        d.value.filter((o) => o !== e)
      );
    }
    const v = S(
      () => {
        var e, t, o;
        return ((t = (e = l.flow) == null ? void 0 : e.selectedScopes) == null ? void 0 : t.length) === Object.keys(((o = l.flow) == null ? void 0 : o.scopes) ?? {}).length;
      }
    ), A = () => {
      var e;
      l.updateScheme(
        `flows.${l.flow.type}.selectedScopes`,
        Object.keys(((e = l.flow) == null ? void 0 : e.scopes) ?? {})
      );
    }, B = () => {
      l.updateScheme(`flows.${l.flow.type}.selectedScopes`, []);
    };
    return (e, t) => (n(), p(s(b), { class: "h-auto !max-h-[initial] min-h-8 items-center" }, {
      default: c(() => [
        i("div", L, [
          t[2] || (t[2] = i("div", { class: "text-c-1 h-full items-center" }, null, -1)),
          u(s(z), {
            as: "div",
            class: "bl flex w-full flex-col"
          }, {
            default: c(() => {
              var o, g;
              return [
                u(s(N), {
                  class: T([
                    "group/scopes-accordion hover:text-c-1 flex h-auto min-h-8 cursor-pointer items-center gap-1.5 pr-2.25 pl-3 text-left",
                    (((g = (o = e.flow) == null ? void 0 : o.selectedScopes) == null ? void 0 : g.length) || 0) > 0 ? "text-c-1" : "text-c-3"
                  ])
                }, {
                  default: c(({ open: a }) => {
                    var f, r, h;
                    return [
                      i("div", M, " Scopes Selected " + m(((r = (f = e.flow) == null ? void 0 : f.selectedScopes) == null ? void 0 : r.length) || 0) + " / " + m(Object.keys(((h = e.flow) == null ? void 0 : h.scopes) ?? {}).length || 0), 1),
                      i("div", P, [
                        v.value ? (n(), p(s(C), {
                          key: 0,
                          class: "pr-0.75 pl-1 transition-none",
                          size: "sm",
                          variant: "ghost",
                          onClick: k(B, ["stop"])
                        }, {
                          default: c(() => t[0] || (t[0] = [
                            x(" Deselect All ")
                          ])),
                          _: 1,
                          __: [0]
                        })) : w("", !0),
                        v.value ? w("", !0) : (n(), p(s(C), {
                          key: 1,
                          class: "pr-0.75 pl-1 transition-none",
                          size: "sm",
                          variant: "ghost",
                          onClick: k(A, ["stop"])
                        }, {
                          default: c(() => t[1] || (t[1] = [
                            x(" Select All ")
                          ])),
                          _: 1,
                          __: [1]
                        })),
                        u(s(R), {
                          class: "text-c-3 group-hover/scopes-accordion:text-c-2",
                          icon: a ? "ChevronDown" : "ChevronRight",
                          size: "md"
                        }, null, 8, ["icon"])
                      ])
                    ];
                  }),
                  _: 1
                }, 8, ["class"]),
                u(s(E), { as: "template" }, {
                  default: c(() => [
                    i("table", U, [
                      (n(!0), y($, null, j(D.value, ({ id: a, label: f, description: r }) => (n(), p(s(F), {
                        key: a,
                        class: "text-c-2",
                        onClick: (h) => V(a, !d.value.includes(a))
                      }, {
                        default: c(() => [
                          u(s(b), { class: "hover:text-c-1 box-border !max-h-[initial] w-full cursor-pointer px-3 py-1.5" }, {
                            default: c(() => [
                              r ? (n(), y("div", q, [
                                i("span", G, m(f), 1),
                                x(" – " + m(r), 1)
                              ])) : w("", !0)
                            ]),
                            _: 2
                          }, 1024),
                          u(s(I), {
                            modelValue: d.value.includes(a),
                            "onUpdate:modelValue": () => {
                            }
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))), 128))
                    ])
                  ]),
                  _: 1
                })
              ];
            }),
            _: 1
          })
        ])
      ]),
      _: 1
    }));
  }
});
export {
  W as default
};
